export default {
  common: {
    table: {
      notfound: 'Sin registros',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/common.js